import React from 'react';
import { Download } from 'lucide-react';
import '../styles/FilePreviewModal.css';

interface FilePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  fileName: string;
  mimeType: string;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  isOpen,
  onClose,
  fileUrl,
  fileName,
  mimeType
}) => {
  if (!isOpen) return null;

  const isImage = mimeType.startsWith('image/');
  const isPDF = mimeType === 'application/pdf';

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="file-preview-modal-overlay" onClick={handleBackdropClick}>
      <div className="file-preview-modal">
        <div className="file-preview-header">
          <h3>{fileName}</h3>
          <div className="file-preview-actions">
            <button
              className="btn btn-secondary btn-md"
              onClick={handleDownload}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <Download size={16} /> Download
            </button>
            <button className="file-preview-close" onClick={onClose}>
              ✕
            </button>
          </div>
        </div>
        <div className="file-preview-content">
          {isImage ? (
            <img src={fileUrl} alt={fileName} className="file-preview-image" />
          ) : isPDF ? (
            <iframe
              src={fileUrl}
              className="file-preview-iframe"
              title={fileName}
            />
          ) : (
            <div className="file-preview-unsupported">
              <p>Preview not available for this file type</p>
              <button className="btn btn-primary btn-md" onClick={handleDownload}>
                Download File
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
